<template>
  <div v-if="masterCampaign">
    <vx-card no-shadow>
      <div class="flex">
        <div class="flex-grow flex-shrink-1 pr-4">
          <h2 class="mt-4">NightPay Push Template</h2>
          <h5 class="my-5" v-if="!isEditable">
            <b>Note: Can no longer be edited as campaign has status {{ masterStatusObject(masterCampaign.masterStatus).text }}.</b>
          </h5>

          <div class="col-8 mb-5">
            <h4 class="my-2">Notification title</h4>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-4/5 max-w-lg">
                <vs-textarea
                  label=""
                  v-model="masterCampaign.npPushInfo.title"
                  height="80px"
                  class="pushContentContainer"
                  ref="textareaTitle"
                  counter="65"
                />
                <vs-chip
                  class="cursor-pointer"
                  @click.native="addHandlebar(item.handlebar, 'Title')"
                  v-for="item in handlebars"
                  :key="item.handlebar"
                >
                  <b>{{ item.name }}</b>
                </vs-chip>
              </div>
            </div>
          </div>

          <div class="col-8 mb-5">
            <h4 class="my-2">Notification body</h4>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-4/5 max-w-lg">
                <vs-textarea
                  label=""
                  v-model="masterCampaign.npPushInfo.body"
                  height="160px"
                  class="pushContentContainer"
                  ref="textareaBody"
                  counter="178"
                />
                <vs-chip
                  class="cursor-pointer"
                  @click.native="addHandlebar(item.handlebar, 'Body')"
                  v-for="item in handlebars"
                  :key="item.handlebar"
                >
                  <b>{{ item.name }}</b>
                </vs-chip>
              </div>
            </div>
          </div>

          <div class="col-8 mb-5">
            <h4 class="my-2">Notification CTA name</h4>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-4/5 max-w-lg">
                <vs-input label="" v-model="masterCampaign.npPushInfo.ctaName" height="160px" class="pushContentContainer w-full mb-2" />
              </div>
            </div>
          </div>

          <div class="col-8 mb-5">
            <h4 class="my-2">Notification CTA url</h4>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-4/5 max-w-lg">
                <vs-input label="" v-model="masterCampaign.npPushInfo.ctaUrl" height="160px" class="pushContentContainer w-full mb-2" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Save & Remove Button -->
      <vs-row vs-justify="flex-end" class="flex flex-wrap items-center" style="margin-top: 32px">
        <vs-button
          v-if="isEditable && hasPermissionForActiveVenue('vp.crm.campaigns.edit')"
          id="save-button"
          @click="$emit('onSave')"
          class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  props: ["masterCampaign", "isEditable"],
  mixins: [campaignMixin],
  computed: {
    handlebars() {
      return this.$store.getters["handlebars/getFor"]("guest", "venue", "sendDate")
        .filter(e => e.handlebar != "venue_openhours" && e.handlebar != "venue_openhours_html")
        .map(e => {
          return {
            handlebar: `{{${e.handlebar}}}`,
            name: e.name,
            description: e.description
          };
        });
    }
  },
  methods: {
    addHandlebar(handlebar, refPostfix) {
      const el = this.$refs["textarea" + refPostfix].$el.children[0];
      const [start, end] = [el.selectionStart, el.selectionEnd];
      el.setRangeText(handlebar, start, end, "select");
      if (refPostfix == "Title") {
        this.masterCampaign.npPushInfo.title = el.value;
      } else {
        this.masterCampaign.npPushInfo.body = el.value;
      }
    }
  }
};
</script>

<style lang="scss">
.pushContentContainer textarea {
  height: 100%;
}
</style>